import { View } from 'react-native';
import { Modal } from '@/components/ui/therapist/Modal';
import { Input } from '@/components/ui/therapist/Input';
import { Button } from '@/components/ui/therapist/Button';
import { Text } from '@/components/Text';
import { TextLink } from '@/components/TextLink';
import { constants } from '@/config/constants';

import { styles } from './styles';

interface DeleteAccountModalProps {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  value: string;
  onChangeValue: (text: string) => void;
}

export const DeleteAccountModal: React.FC<DeleteAccountModalProps> = ({
  isVisible,
  onClose,
  onConfirm,
  value,
  onChangeValue,
}) => {
  return (
    <Modal
      isContentScrollable={true}
      isVisible={isVisible}
      title="Konto löschen"
      onClose={onClose}
      cancelActionButton={
        <Button look="tertiary" label="Abbrechen" onPress={onClose} />
      }
      confirmActionButton={
        <Button
          look="danger"
          icon="trash"
          label="Unwiderruflich Löschen"
          disabled={value.toLowerCase() !== 'löschen'}
          onPress={onConfirm}
        />
      }
    >
      <View>
        <View style={{ gap: 16 }}>
          <Text style={styles.text}>
            Wenn Sie die vollständige und unwiderrufliche Löschung aller Ihrer
            bei uns gespeicherten Daten und Ihres gesamten Benutzerkontos
            wünschen, bestätigen Sie dies bitte mit dem Klick auf
            „unwiderruflich löschen". Bitte beachten Sie, dass diese Löschung
            nicht wieder rückgängig gemacht werden kann. Falls Sie dies
            wünschen, können Sie vor der Löschung Ihre Daten{' '}
            <TextLink href={constants.webAppUrl}>hier</TextLink> unter "Mein
            Account" exportieren und abspeichern.
          </Text>

          <View style={{ flexDirection: 'row' }}>
            <View style={styles.leftBorder} />
            <Text style={styles.text}>
              Ein bestehendes Abonnement bleibt bestehen und muss separat
              gekündigt werden.
            </Text>
          </View>

          <View style={styles.longLabelContainer}>
            <Input
              required
              label="Zum Bestätigen tippen Sie bitte das Wort “Löschen” in das Eingabefeld ein."
              onChange={(text) => onChangeValue(text)}
              value={value}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};
